export const MAIN_PAGE_TITLE = 'Abonoteatro - Backoffice';

export const DEFAULT_ACCOMPANYING_TICKET_PRICE = 5;
export const DEFAULT_SUBSCRIBER_COSTS = 3.5;
export const DEFAULT_ACCOMPANYING_COSTS = 3.5;

export const DEFAULT_IMAGE_MAX_WIDTH = 1000;
// TODO: pending to restore temporary '350' to default value '700'
export const DEFAULT_IMAGE_MIN_HEIGHT = 350;
export const DEFAULT_IMAGE_MAX_HEIGHT = 1400;
export const DEFAULT_IMAGE_DIFFERENCE = 400;

export const DEFAULT_IMAGE_SRC = '/image-default.svg';
export const DEFAULT_IMAGE_PDF_SRC = '/image-pdf.png';
export const DEFAULT_IMAGE_LOGIN_BG_SRC = '/login-bg.jpg';
